import * as React from 'react';
import './RssItemsCmp.css';
import RssItemCmp from './RssItemCmp';
import { RssItem } from '../../types';

interface RssItemsCmpProps {
  items: RssItem[];
}

export default function RssItemsCmp(props: RssItemsCmpProps) {
  if (!props.items) return null;

  return (
    <div>
      {props.items.map((rssItem) => (
        <RssItemCmp key={rssItem.id} item={rssItem} />
      ))}
    </div>
  );
}
